module.exports = __webpack_public_path__ + "static/media/TabletHotels.bc0d24e6.ico";